import { Device } from "@/models/Device";
import { toTranslationKey } from "@/utils/stringFormat";
import { DigitalSignageTV } from "@/models/digital-signage/DigitalSignageTV";

export default {
  name: "DevicesList",
  data() {
    return {
      search: "",
      headers: [
        {
          align: "start",
          value: "id",
          width: 20,
          show: true,
          sortable: false
        },
        {
          text: this.$t('DevicesList.Brand'),
          value: "brand",
          width: 200,
          show: true
        },
        {
          text: this.$t('DevicesList.Model'),
          value: "model",
          width: 200,
          show: true
        }, 
        {
          text: this.$t('DevicesList.FriendlyName'),
          value: "friendlyName",
          width: 200,
          show: true
        },
        {
          text: this.$t('DevicesList.OwnerName'),
          value: "userName",
          width: 200,
          show: true
        },
        {
          text: this.$t('DevicesList.UserType'),
          value: "userType",
          show: true
        },
        {
          text: this.$t('DevicesList.MyHubVersion'),
          value: "version",
          show: true
        },
        {
          text: this.$t('DevicesList.AssignedDateTime'),
          value: "assignedDateTime",
          show: true
        },
        {
          text: this.$t('DevicesList.LastActive'),
          value: "lastActive",
          show: true
        }
      ]
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    devices(): Device[] {
      return this.$store.state.devicesModule.devices;
    },
    digitalSignageTVList(): DigitalSignageTV[] {
      return this.$store.state.digitalSignageModule.digitalSignageTVList;
    },
    allDevices() {
      return [
        ...(Array.isArray(this.digitalSignageTVList) ? this.digitalSignageTVList : []),
        ...(Array.isArray(this.devices) ? this.devices : []),
      ];
    },
    computedHeaders () {
      return this.headers.filter(x=>x.show === true)  
    },
  },
  methods: {
    handleClickDevice(row): void {
      if(row.isDigitalSignageTV) {
        this.$router.push({ path: `/devices/${row.id}?deviceType=digitalSignageTV` });
      } else {
        this.$router.push({ path: `/devices/${row.id}` });
      }
    },
    isUsingOwnDevice(item) {
      if(item.isKiosk) return 'N/A';
      
      return item.isUsingOwnDevice ? this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Yes'] : this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.No'];
    },
    convertToTranslationKey(text: string){
      return toTranslationKey(text)
    }
  },
  mounted(): void {
    this.$store.dispatch("getDigitalSignageTVList");
    this.$store.dispatch("getDevices");
    //load settings that may have changed in the Facility Settings
    this.$store.dispatch("getFacility")
  }
}
